(function (global){
// run the polyfills
require('./polyfill');

var core = module.exports = require('./core');

// add core plugins.
core.extras         = require('./extras');
core.filters        = require('./filters');
core.interaction    = require('./interaction');
core.loaders        = require('./loaders');
core.mesh           = require('./mesh');

// export a premade loader instance
/**
 * A premade instance of the loader that can be used to loader resources.
 *
 * @name loader
 * @memberof PIXI
 * @property {PIXI.loaders.Loader}
 */
core.loader = new core.loaders.Loader();

// mixin the deprecation features.
Object.assign(core, require('./deprecation'));

// Always export pixi globally.
global.PIXI = core;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vZGVfbW9kdWxlcy9waXhpLmpzL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIi8vIHJ1biB0aGUgcG9seWZpbGxzXG5yZXF1aXJlKCcuL3BvbHlmaWxsJyk7XG5cbnZhciBjb3JlID0gbW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKCcuL2NvcmUnKTtcblxuLy8gYWRkIGNvcmUgcGx1Z2lucy5cbmNvcmUuZXh0cmFzICAgICAgICAgPSByZXF1aXJlKCcuL2V4dHJhcycpO1xuY29yZS5maWx0ZXJzICAgICAgICA9IHJlcXVpcmUoJy4vZmlsdGVycycpO1xuY29yZS5pbnRlcmFjdGlvbiAgICA9IHJlcXVpcmUoJy4vaW50ZXJhY3Rpb24nKTtcbmNvcmUubG9hZGVycyAgICAgICAgPSByZXF1aXJlKCcuL2xvYWRlcnMnKTtcbmNvcmUubWVzaCAgICAgICAgICAgPSByZXF1aXJlKCcuL21lc2gnKTtcblxuLy8gZXhwb3J0IGEgcHJlbWFkZSBsb2FkZXIgaW5zdGFuY2Vcbi8qKlxuICogQSBwcmVtYWRlIGluc3RhbmNlIG9mIHRoZSBsb2FkZXIgdGhhdCBjYW4gYmUgdXNlZCB0byBsb2FkZXIgcmVzb3VyY2VzLlxuICpcbiAqIEBuYW1lIGxvYWRlclxuICogQG1lbWJlcm9mIFBJWElcbiAqIEBwcm9wZXJ0eSB7UElYSS5sb2FkZXJzLkxvYWRlcn1cbiAqL1xuY29yZS5sb2FkZXIgPSBuZXcgY29yZS5sb2FkZXJzLkxvYWRlcigpO1xuXG4vLyBtaXhpbiB0aGUgZGVwcmVjYXRpb24gZmVhdHVyZXMuXG5PYmplY3QuYXNzaWduKGNvcmUsIHJlcXVpcmUoJy4vZGVwcmVjYXRpb24nKSk7XG5cbi8vIEFsd2F5cyBleHBvcnQgcGl4aSBnbG9iYWxseS5cbmdsb2JhbC5QSVhJID0gY29yZTtcbiJdfQ==